import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as _ from "lodash";
import { ToastrService } from "ngx-toastr";
import { CostRegistrationRelations } from "../../../models/cost_registration_relations";
import { Institution } from "../../../models/institution";
import { InstitutionRegistrationRelations } from "../../../models/institution_registration_relations";
import { Page } from "../../../models/page";
import { CostRegistrationsControllerService } from "../../../services/crossed-tables/cost-registrations-controller.service";
import { InstitutionRegistrationsControllerService } from "../../../services/crossed-tables/institution-registrations-controller.service";
import { InstitutionControllerService } from "../../../services/institution-controller/institution-controller.service";
import { InstitutionService } from "../../../services/institution-controller/institution.service";
import { BaseError } from "../base-error";

@Component({
  selector: "app-institution-registrations",
  templateUrl: "./institution-registrations.component.html",
  providers: [InstitutionRegistrationsControllerService],
})
export class InstitutionRegistrationsComponent extends BaseError implements OnInit {
  public institutionRegistrationRelations: InstitutionRegistrationRelations[][] = [];
  public institutionRegRelations: InstitutionRegistrationRelations[][] = [];
  public serviceId: string;
  public selectedInstitutionRegistrationRelations: InstitutionRegistrationRelations;
  public institutions: Institution[] = [];
  public institution: Institution = new Institution();
  public tableSwitched: boolean = false;

  constructor(private institutionRegistrationsControllerService: InstitutionRegistrationsControllerService,
              private institutionControllerService: InstitutionControllerService,
              private institutionService: InstitutionService,
              private route: ActivatedRoute,
              toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
    this.loadInstitutions();
  }

  public loadInstitutions() {
    this.institutionControllerService.getInstitutions().subscribe(
      (data) => {
        this.institutions = data;
        this.getInstitutionRegistrationRelations();
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public getInstitutionRegistrationRelations() {
    if (this.institutions && this.institutions.length > 0) {
      this.institutionRegistrationsControllerService.getInstitutionRegistrationsRelationsList(this.serviceId, this.institutions).subscribe(
        (data) => {
          this.institutionRegistrationRelations = data;
          this.fillShortName();
          if (this.tableSwitched) {
            this.tableSwitched = false;
            this.switchHeadings();
          }
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
      );
    }
  }

  public fillShortName() {
    if (this.institutionRegistrationRelations[0]) {
      this.institutionRegistrationRelations[0].forEach((item) => {
        const institution = this.institutions.find((inst) => inst.id.toString() === item.institutionId);
        item.institutionShortName = institution === null ? item.institutionName.substring(0, 20) : (institution.shortName === null ? item.institutionName.substring(0, 20) : institution.shortName);
      });
    }
  }

  public updateInstitutionRegistration(institutionRegistrationRelations: InstitutionRegistrationRelations) {
    this.institutionRegistrationsControllerService.saveInstitutionRegistrations(this.serviceId, institutionRegistrationRelations).subscribe(
      (data) => {
        this.getInstitutionRegistrationRelations();
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  public editInstitutionRegistration(institutionRegistrationRelations: InstitutionRegistrationRelations) {
    if (institutionRegistrationRelations) {
      this.selectedInstitutionRegistrationRelations = institutionRegistrationRelations;
      if (institutionRegistrationRelations.registrationHasInstitution) {
        this.selectedInstitutionRegistrationRelations.registrationHasInstitution = false;
        this.updateInstitutionRegistration(this.selectedInstitutionRegistrationRelations);
      } else {
        institutionRegistrationRelations.registrationHasInstitution = true;
        this.updateInstitutionRegistration(institutionRegistrationRelations);
      }
    }

  }

  public switchHeadings() {
    this.tableSwitched = !this.tableSwitched;
    const switchedEntries = [];
    if (this.institutionRegistrationRelations[0]) {
      for (let j = 0; j < this.institutionRegistrationRelations[0].length; j++) {
        const newRow = [];
        for (let i = 0; i < this.institutionRegistrationRelations.length; i++) {
          newRow.push(this.institutionRegistrationRelations[i][j]);
        }
        switchedEntries.push(newRow);
      }
      this.institutionRegistrationRelations = switchedEntries;
    }
  }
}
